import { useNavigate, useSearchParams } from 'react-router'
import { useState } from 'react'
import { useClientLang } from '~/utils/i18n.utils'
import { clearSearchPlaceParams } from './searchbox.helper'

type RadiusSliderProps = {
	initialValue: number
	isVisible: boolean
}

export default function SearchBoxRadiusSlider({
	initialValue,
	isVisible,
}: RadiusSliderProps) {
	const navigate = useNavigate()
	const lang = useClientLang().lngShort
	const [sliderValue, setSliderValue] = useState(initialValue)

	const [searchParams] = useSearchParams()
	const sp = clearSearchPlaceParams(searchParams)

	const handleRadiusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSliderValue(parseInt(e.target.value))
	}

	const handleRadiusChangeComplete = () => {
		const newSp = new URLSearchParams(sp.toString())
		newSp.set('radius', sliderValue.toString())
		navigate(
			`${lang === 'sv' ? '' : `/${lang}`}/place?nearby=true${
				newSp.size > 0 ? '&' + newSp.toString() : ''
			}`,
		)
	}

	if (!isVisible) return null

	return (
		<div className="flex w-full items-center gap-2 px-2" key="radius-slider">
			<input
				type="range"
				min={1}
				max={250}
				value={sliderValue}
				onChange={handleRadiusChange}
				onMouseUp={handleRadiusChangeComplete}
				onTouchEnd={handleRadiusChangeComplete}
				className="accent-secondary cursor-pointer"
			/>
			<span className="text-sm font-medium whitespace-nowrap">
				{sliderValue} km
			</span>
		</div>
	)
}
